import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | 'disclaimer' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const modalContent: Record<Exclude<ModalType, null>, {
    title: string;
    body: string[];
  }> = {
    privacy: {
      title: 'Política de Privacidad',
      body: ['En IA al Rescate, respetamos tu privacidad y nos comprometemos a proteger tu información personal.', 'Recopilamos únicamente los datos necesarios para procesar tu compra y entregarte el producto digital (nombre y correo electrónico).', 'No compartimos, vendemos ni distribuimos tu información personal a terceros bajo ninguna circunstancia.', 'Tu correo electrónico será utilizado exclusivamente para enviarte el enlace de descarga y, si lo autorizas, actualizaciones futuras del producto.', 'Puedes solicitar la eliminación de tus datos en cualquier momento contactándonos directamente.', 'Utilizamos medidas de seguridad estándar de la industria para proteger tu información.']
    },
    terms: {
      title: 'Términos de Servicio',
      body: ['Al adquirir la guía "IA al Rescate", aceptas los siguientes términos y condiciones.', 'El producto es un archivo digital (PDF) de descarga inmediata. Una vez completada la compra, recibirás acceso instantáneo al contenido.', 'La guía es para uso personal y no puede ser redistribuida, revendida ni compartida sin autorización expresa.', 'Debido a la naturaleza digital del producto, no se aceptan devoluciones una vez realizada la descarga.', 'El contenido de la guía es informativo y educativo. Los resultados pueden variar según el uso individual.', 'Nos reservamos el derecho de actualizar estos términos en cualquier momento. Las actualizaciones serán comunicadas por correo electrónico.']
    },
    disclaimer: {
      title: 'Descargo de Responsabilidad',
      body: ['La guía "IA al Rescate" es un recurso educativo diseñado para ayudarte a optimizar el uso de ChatGPT y herramientas de IA en tu vida diaria.', 'Los resultados mencionados en esta página son ejemplos basados en experiencias reales de usuarios, pero no garantizamos resultados específicos.', 'El rendimiento individual depende de factores como la dedicación, el tipo de tareas y la frecuencia de uso.', 'Este producto no está afiliado, patrocinado ni respaldado por OpenAI ni por ninguna otra empresa de inteligencia artificial.', 'Los testimonios presentados reflejan experiencias individuales y pueden no ser representativos de todos los usuarios.', 'Al utilizar los prompts y estrategias de esta guía, asumes la responsabilidad de verificar y adaptar las respuestas de la IA a tu contexto específico.']
    }
  };
  return <>
      <footer className="bg-[#040408] border-t border-cyan-neon/10 py-12 px-6" data-id="element-50">
        <div className="max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-51">
          <div className="mb-8" data-id="element-52">
            <h2 className="text-2xl font-black text-cyan-neon mb-2" data-id="element-53">
              IA al Rescate
            </h2>
            <p className="text-slate-400" data-id="element-54">
              Domina ChatGPT y simplifica tu vida en minutos.
            </p>
          </div>

          <nav className="flex flex-wrap justify-center gap-6 md:gap-8 mb-8" data-id="element-55">
            <a href="#" className="text-slate-400 hover:text-cyan-neon transition-colors font-medium" data-id="element-56">
              Inicio
            </a>
            <a href="#que-incluye" className="text-slate-400 hover:text-cyan-neon transition-colors font-medium" data-id="element-57">
              Qué incluye
            </a>
            <a href="#faq" className="text-slate-400 hover:text-cyan-neon transition-colors font-medium" data-id="element-58">
              FAQ
            </a>
          </nav>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-slate-500 mb-8" data-id="element-59">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-slate-300 transition-colors underline underline-offset-2" data-id="element-60">
              Política de Privacidad
            </button>
            <span className="text-slate-600" data-id="element-61">|</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-slate-300 transition-colors underline underline-offset-2" data-id="element-62">
              Términos de Servicio
            </button>
            <span className="text-slate-600" data-id="element-63">|</span>
            <button onClick={() => setActiveModal('disclaimer')} className="hover:text-slate-300 transition-colors underline underline-offset-2" data-id="element-64">
              Descargo de Responsabilidad
            </button>
          </div>

          <p className="text-slate-600 text-sm" data-id="element-65">
            © 2024 IA al Rescate. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {/* Legal Modals */}
      <AnimatePresence data-id="element-66">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-67">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="bg-navy-900 border border-cyan-neon/20 rounded-2xl shadow-[0_0_40px_rgba(0,242,255,0.1)] max-w-lg w-full max-h-[80vh] overflow-hidden flex flex-col" data-id="element-68">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-cyan-neon/10" data-id="element-69">
                <h3 className="text-xl font-bold text-white" data-id="element-70">
                  {modalContent[activeModal].title}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/5" aria-label="Cerrar" data-id="element-71">
                  <XIcon className="w-5 h-5" data-id="element-72" />
                </button>
              </div>

              {/* Body */}
              <div className="p-6 overflow-y-auto space-y-4" data-id="element-73">
                {modalContent[activeModal].body.map((paragraph, i) => <p key={i} className="text-slate-300 leading-relaxed text-sm" data-id="element-74">
                    {paragraph}
                  </p>)}
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-cyan-neon/10" data-id="element-75">
                <button onClick={() => setActiveModal(null)} className="w-full bg-cyan-neon/10 hover:bg-cyan-neon/20 text-cyan-neon font-semibold py-3 rounded-xl transition-colors" data-id="element-76">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}